import { CurrencyAmount } from "util/currency";
import { Bounds2D, Margins2D, Size2D, Vector3D } from "util/geometry";
import { DateTime } from "util/time";
import { Image } from "../../services/entities/content";

type GoogleLatLng = google.maps.LatLng;

export enum SpaceStatus {
  Available = "available",
  Preview = "preview",
  Hidden = "hidden",
}

export enum FootfallPeriod {
  Week = "week",
  Hour = "hour",
}

export enum SpaceAmenityType {
  FittingRoom = "fitting-room",
  CashDesk = "cash-desk",
  AdjustableShelving = "adjustable-shelving",
  Lighting = "lighting",
  ColoredLighting = "colored-lighting",
  Heating = "heating",
  Wifi = "wifi",
  AirConditioning = "air-conditioning",
  Toilets = "toilets",
  StockRoom = "stock-room",
  WheelchairAccess = "wheelchair-access",
  Speakers = "speakers",
}

export interface SpaceAmenity {
  type: SpaceAmenityType;
  name: string | null;
}

export enum SpaceImageType {
  Banner = "banner",
  Gallery = "gallery",
}

export interface SpaceImage {
  url: string;
  type: SpaceImageType;
}

export interface SpaceStaff {
  name: string;
  title: string;
  imageURL: string;
}

export interface Space {
  name: string;
  code: string;
  pageTitle: string;
  metaDescription: string;
  regions: SpaceRegion[];
  shortAddress: string | null;
  city: string | null;
  address: string | null;
  shortDescription: string | null;
  description: string | null;
  mapURL: string | null;
  mapImageURL: string | null;
  latlong: string | null;
  tourDescription: string | null;
  tourURL: string | null;
  floorPlanURL: string | null;
  floorArea: number | null;
  footfall: number | null;
  footfallPeriod: FootfallPeriod;
  samplePrice: CurrencyAmount | null;
  heroImage: string;
  designerEnabled: boolean;
  previewerEnabled: boolean;
  bookingEnabled: boolean;
  status: SpaceStatus;
  images: Image[];
  amenities: SpaceAmenity[];
  staff: SpaceStaff[];
  answers: SpaceAnswer[];
  quotes: SpaceQuotes[];
  pageType: string;
  url: string;
}

export interface SpaceRegion {
  name: string;
  code: string;
  size: Size2D;
  screenGroups: SpaceScreenGroup[];
}

export interface SpaceScreen {
  bounds: Bounds2D;
  rotation: number;
  bezels: Margins2D;
}

export interface SpaceScreenGroup {
  name: string;
  code: string;
  bounds: Bounds2D;
  resolution: Size2D;
  isDesignHero: boolean;
  screens: SpaceScreen[];
}

export interface SpaceAnswer {
  question: string;
  answer: string;
}

export interface SpacePreviewScreen {
  code: string;
  size: Size2D;
  position: Vector3D;
  rotation: Vector3D;
}

export interface SpacePreview {
  name: string;
  background: URL;
  foreground: URL | null;
  camera: { position: Vector3D; rotation: Vector3D; fov: number };
  screens: SpacePreviewScreen[];
}

export enum SpaceAnalyticsMetric {
  PassingCount = "passing_count",
  EntranceCount = "entrance_count",
  MaleCount = "male_count",
  FemaleCount = "female_count",
  Age = "age",
}

export type SpaceAnalyticsValues = Map<SpaceAnalyticsMetric, number>;

export interface SpaceAnalyticsGroup {
  startTime: DateTime;
  endTime: DateTime;
  values: SpaceAnalyticsValues;
}

export interface SpaceQuotes {
  quote: string;
  customerName: string | null;
  company: string | null;
  avatar: string | null;
}
